// extracted by mini-css-extract-plugin
export var horizontalLine = "horizontal-line-separator-desktop-module--horizontal-line---MiRo";